export default "__VITE_ASSET__Di40bfQK__"